export default "__VITE_ASSET__iRaenWEq__"